<template>
  <div id="home_foot_base">
    <div style="width: 300px; position: relative; left: 50%; margin-left: -150px; line-height: 40px;">
        <a target="_blank" href="/">不知道写什么</a>
        <a target="_blank" href="http://www.baidu.com">百度</a>
        <a target="_blank" href="http://www.sina.com">新浪</a>
        <a target="_blank" href="https://weibo.com/">微博</a>
        <a target="_blank" href="https://www.meituan.com/">美团</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot1',
  data() {
    return {
      msg: '这是Foot1组件'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Foot1.vue